<div class="container"  style="min-height: 125vh;"  *ngFor="let data of dataProfile">

  <div style="justify-content:center;">

    <div style="display: flex; flex-direction:column; align-items: center;">

      <div style="display: flex;">
        <h2 style="text-transform: capitalize; text-shadow: 3px 3px 5px white;">{{data.name}}</h2>
        <div style="margin-left: 50px;">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #menu="matMenu">
            <button (click)='modalEdit("perfil")' mat-menu-item>
              <mat-icon>edit</mat-icon>
              <span>Editar Perfil</span>
            </button>
            <button mat-menu-item (click)='modalEdit("contrasena")'>
              <mat-icon>vpn_key</mat-icon>
              <span>Cambiar contraseña</span>
            </button>
            <button mat-menu-item (click)='modalEdit("foto")'>
              <mat-icon>add_a_photo</mat-icon>
              <span>Editar foto</span>
            </button>
            <!-- <button mat-menu-item [matMenuTriggerFor]="Temas">
              <mat-icon>format_paint</mat-icon>
              <span>Tema</span>
            </button> -->

          </mat-menu>

          <!-- <mat-menu #Temas="matMenu">
            <button mat-menu-item>dark</button>
            <button mat-menu-item>light</button>
          </mat-menu> -->

        </div>

      </div>

      <img class="mat-elevation-z8" src="{{userPicture}}" [ngStyle]="sizePicture">
    </div>


  </div>

  <div style="text-transform: capitalize;">
    <mat-tab-group mat-stretch-tabs class="example-stretched-tabs mat-elevation-z1">
      <mat-tab label="Información Personal">
        <mat-list>
          <mat-list-item>Nombre: {{data.name}}</mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item>Usuario: {{data.user}}</mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item *ngIf="data.phone>0">Telefono: {{data.phone}}</mat-list-item>
          <mat-divider>*ngIf="data.phone> 0"></mat-divider>
          <mat-list-item *ngIf="data.email!=''">Correo: {{data.email}}</mat-list-item>
          <mat-divider> *ngIf="data.email!=''"></mat-divider>
          <mat-list-item>Ciudad: {{data.cityName}}</mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item *ngIf="data.address!=''">Direccion: {{data.address}}</mat-list-item>
          <mat-divider> *ngIf="data.address!''"></mat-divider>
          <mat-list-item>Fecha Ingreso: {{fechaIngreso}} </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item>Antigüedad: {{antiguedad}}</mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item>cv:
              <mat-icon style="margin-left: 7px;" (click)='openCV()'>assignment_ind</mat-icon>
            </mat-list-item>
          <mat-divider></mat-divider>
          <!-- <mat-list-item><strong>Informacion Usuario: </strong>
            <mat-icon style="margin-left: 7px;" (click)='report()'>picture_as_pdf</mat-icon>
          </mat-list-item> -->




        </mat-list>
      </mat-tab>

      <mat-tab label="Información adicional">
        <mat-list>
          <mat-list-item>Area: {{data.areaName}}</mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item>Cargo: {{data.jobTitleName}}</mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item *ngIf="data.emergencyContact!=''">Contacto de emergencia: {{data.emergencyContact}}</mat-list-item>
          <mat-divider>*ngIf="data.emergencyContact!=''"></mat-divider>
          <mat-list-item *ngIf="data.emergencyContactPhone> 0">contacto de emergencia : {{data.emergencyContactPhone}}</mat-list-item>
          <mat-divider> *ngIf="data.emergencyContactPhone> 0"</mat-divider>
          <mat-list-item>EPS: {{data.epsName}}</mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item>ARL: {{data.arlName}}</mat-list-item>
          <mat-divider></mat-divider>

        </mat-list>
      </mat-tab>

    </mat-tab-group>
  </div>

</div>
